/* 
Inputs: 
            imgURL - image to resize (in most cases it will be objectURL)
            maxSide - will resize longest side of image to this value
            imageQuality - how sick the selfie looks
Outputs:
            result[0] - resizedImgURL - objectURL
            result[1] - imgDims - {oldHeight, oldWidth, newHeight, newWidth, aspectRatio}
*/

// pica option 1: 
// webworkify is used by pica so it might need to be loaded in this component for it to thread 
// https://github.com/nodeca/pica/blob/e12af7c3a4d47db0537688e924dc304d6296f75e/dist/pica.js#L1796-L1817
const pica = require("pica/dist/pica")({ features: [ 'js', 'wasm', 'ww'] }); // < this creates web worker for some reason

const resizeImage = (imgURL, maxSide, imageQuality) => {
    return new Promise((resolve, reject) => {
        //
        // PICA - Resize on import option #1 (faster than jimp but quality is meh and i cant figure out webworkers)
        //                
        
        var oldWidth, oldHeight, newWidth, newHeight, resizedImgURL;

        // Provide default values
        var imageType = imageType || "image/jpeg";

        // Create a temporary image so that we can compute the height of the downscaled image.
        // then create a canvas for Pica to process on
        const srcImage = new Image()
        srcImage.src = imgURL
        
        srcImage.onload = function() {
            oldWidth = srcImage.width;
            oldHeight = srcImage.height;
            // landscape
            if (oldWidth > maxSide && oldWidth > oldHeight) {
                newWidth = maxSide;
                newHeight = Math.floor(oldHeight / oldWidth * newWidth);                            
            // portrait
            } else if (oldHeight > maxSide && oldHeight > oldWidth) {
                newHeight = maxSide;
                newWidth = Math.floor(oldWidth / oldHeight * newHeight);
            // square
            } else if (oldHeight === oldWidth && oldHeight > maxSide) {
                newHeight = maxSide;
                newWidth = maxSide;
            // do not scale
            } else {
                newWidth = oldWidth;
                newHeight = oldHeight;                          
            }  

            let imgDims = {
                oldHeight: Number(oldHeight),
                oldWidth: Number(oldWidth),
                newHeight: Number(newHeight),
                newWidth: Number(newWidth),
                aspectRatio: Number(oldWidth/oldHeight)
            }
                            
            const tmpCanvas = document.createElement('canvas')

            tmpCanvas.height = newHeight;
            tmpCanvas.width = newWidth;

            pica
            .resize(srcImage, tmpCanvas, {
                alpha: true,
                quality: 3,
                unsharpAmount: 0,
                unsharpRadius: 0.6,
                unsharpThreshold: 40,
            })
            .then(result => {
                /*  If you want add favorite to images being resized, use this section
                    the snippet includes logic to hijack Pica's canvas and apply the wm before exporting canvas                                 
                    >> https://bitbucket.org/snippets/integrateus/KjRrzz
                */

                tmpCanvas.toBlob(blob => {
                    resizedImgURL = URL.createObjectURL(blob);                      
                    resolve([resizedImgURL, imgDims]) // return promise so I can chain starting next photo                                 
                },imageType, imageQuality/100)                                               
            })
        }
    })
}

export { resizeImage };